import React, { useEffect, useState } from "react";
import "../styles/ViewProfile.css";
import ViewProfileHeader from "./ViewProfileHeader";
import { ToastContainer, toast } from "react-toastify";
import back_arrow from "../assets/svg/back-arrow.svg";
import user_icon from "../assets/svg/user_icon.svg";
import info_icon from "../assets/svg/info_icon.svg";
import { FiUser, FiMapPin, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { MdPhoneAndroid } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";

const ViewProfile = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    useEffect(() => {
        fetchProfile();
        // fetchProjects();
    }, []);

    const fetchProfile = async () => {
        try {
            const response = await axiosInstance.get("/userProjects");
            if (response.data.success) {
                setUser(response.data.user);
                setProjects(response.data.projects);

            } else {
                toast.error("Failed to load profile data");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong while fetching profile");
        } finally {
            setLoading(false);
        }
    };

    // const fetchProjects = async () => {
    //     try {
    //         const response = await axiosInstance.get("/userProjects");
    //         if (response.data.success) {
    //         } else {
    //             toast.error("Failed to load projects");
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         toast.error("Something went wrong while fetching projects");
    //     }
    // };

    if (loading) return <p>Loading...</p>;
    if (!user) return <p>No user data found</p>;

    const totalPages = Math.ceil(projects.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedProjects = projects.slice(startIndex, startIndex + itemsPerPage);


    return (
        <>
            <ViewProfileHeader onSearch={null} disableSearch={true} />
            <div className="view-profile">
                {/* Header */}
                <div className="invoice-module-header">
                    <div className="invoice-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{user.first_name} {user.last_name}</p>
                    </div>
                    {/* <div className="invoice-module_header_right">
                        <button className="edit_btn" onClick={() => navigate(-1)}>Cancel</button>
                    </div> */}
                </div>

                {/* User Details */}
                <div className="view-profile-user-details">
                    <h3 className="view-profile-user-details-header">User Details</h3>
                    <div className="view-profile-user-details-content">
                        <div className="view-profile-user-details-left-side">
                            <div className="view-profile-profile-card">
                                <img src={user.profile_image || user_icon} style={{ width: "120px", height: "120px" }} alt="Profile" />
                                <h4 className="view-profile-profile-name">{user.first_name} {user.last_name}</h4>
                                <p className="view-profile-profile-email">{user.email}</p>
                                <span className="view-profile-profile-role">{user.designation}</span>
                            </div>
                        </div>

                        <div className="view-profile-user-details-right-side">
                            {/* <div className="view-profile-user-details-header">
                                <h4>User details</h4>
                                <div className="view-profile-user-status">
                                    <span className="view-profile-status-dot"></span>
                                    <span>Active</span>
                                    <i className="view-profile-arrow-down"></i>
                                </div>
                            </div> */}
                            <div className="view-profile-user-info">
                                <div className="view-profile-user-info-item">
                                    <FiUser size={12} color="#2563EB" className="view-profile-info-icon" />
                                    <div>
                                        <p className="view-profile-info-label">Employee ID</p>
                                        <p className="view-profile-info-value">{user.employee_id}</p>
                                    </div>
                                </div>

                                <div className="view-profile-user-info-item">
                                    <MdPhoneAndroid size={12} color="#2563EB" className="view-profile-info-icon" />
                                    <div>
                                        <p className="view-profile-info-label">Mobile number</p>
                                        <p className="view-profile-info-value">{user.contact_number}</p>
                                    </div>
                                </div>

                                <div className="view-profile-user-info-item">
                                    <FiMapPin size={12} color="#2563EB" className="view-profile-info-icon" />
                                    <div>
                                        <p className="view-profile-info-label">Location</p>
                                        <p className="view-profile-info-value">{user.city}, {user.state}, {user.country}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="view-profile-created-info">
                        <img src={info_icon} alt="Info" className="view-profile-created-icon" />
                        <span>Created at {user.doj} by {user.reporting_person}</span>
                    </div> */}
                </div>

                {/* Projects Table */}
                <div className="view-profile-table">
                    <div className="view-profile-table-header">
                        Total Projects: {projects.length}
                    </div>

                    <div className="view-profile-table-content">
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Project Code</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedProjects.map((proj, index) => {
                                    const [code, name] = proj.project_details.split(" - ");
                                    return (
                                        <tr key={proj.id}>
                                            <td>{startIndex + index + 1}</td>
                                            <td>{code}</td>
                                            <td>{name}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="view-profile-table-pagination">
                        <div className="pagination-left">
                            <label>
                                Items per page:
                                <select
                                    value={itemsPerPage}
                                    onChange={(e) => {
                                        setItemsPerPage(parseInt(e.target.value));
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </select>
                            </label>
                        </div>
                        <div className="pagination-right">
                            <button
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                <FiChevronLeft size={16} />
                            </button>

                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    className={currentPage === i + 1 ? "active" : ""}
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}

                            <button
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                <FiChevronRight size={16} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default ViewProfile;
